export const wilate = [
  {
    code: 'D68.04',
    description: 'Acquired von Willebrand disease',
  },
  {
    code: 'D68.09',
    description: 'Other von Willebrand disease',
  },
  {
    code: 'D68.0',
    description: "Von Willebrand's disease",
  },
  {
    code: 'D68.00',
    description: 'Von Willebrand disease, unspecified',
  },
  {
    code: 'D68.01',
    description: 'Von Willebrand disease, type 1',
  },
  {
    code: 'D68.020',
    description: 'Von Willebrand disease, type 2A',
  },
  {
    code: 'D68.021',
    description: 'Von Willebrand disease, type 2B',
  },
  {
    code: 'D68.022',
    description: 'Von Willebrand disease, type 2M',
  },
  {
    code: 'D68.023',
    description: 'Von Willebrand disease, type 2N',
  },
  {
    code: 'D68.029',
    description: 'Von Willebrand disease, type 2, unspecified',
  },
  {
    code: 'D68.03',
    description: 'Von Willebrand disease, type',
  },
  {
    code: 'D68.311',
    description: 'Acquired Hemophilia',
  },
];
